<template>
  <div>
    <div v-if="storedProject" class="layout__content__content layout__content__content--white admin-page__content">
      <form>
        <div class="d-flex align-items-center justify-content-between">
          <div>
            <h2 class="mb-0">
              {{ $t("sluzbyALimity") }}
            </h2>
            {{ $t("proProjekt") }} {{ storedProject.projectName }}
          </div>
          <!--button
          class="btn btn-primary d-flex align-items-center justify-content-center">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg">
          </div>
          {{ $t("ulozitZmeny") }}
        </button-->
        </div>
      </form>
      <div v-if="services.length === 0 && !loading">
        <RadioHelp
          :article-link="'/napoveda-menu-spravce/project/no-service'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="services.length > 0 && !loading" class="mt-6 mb-5">
        <RadioHelp
          :article-link="'/napoveda-menu-spravce/project/found-service'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div class="detail-page__tabs__header d-flex">
        <div class="d-flex align-items-end detail-page__tabs__wrapper">
          <RadioOpenClose
            :radio-slides="radioSlides"
            :show="showHelp"
            @update-show-radio-help="showRadioHelp($event)"
          />
        </div>
      </div>
      <div class="mt-4">
        <CustomTable
          :columns="[
            { name: 'custServiceName', sortable: true, action: 'openModal1' },
            { name: 'custServiceId', sortable: true },
            { name: 'tarifName', sortable: true },
            { name: 'devices.count', sortable: true },
            { name: 'custState', sortable: true }
          ]"
          :empty-text="'NO_RESULT_PROJECT_SERVICE'"
          :item-id="'custServiceId'"
          :items="services"
          :kebab="false"
          :loading="loading"
          :selectable="false"
          class="services"
          @open-modal1="openServiceDetail"
          @opened="openItem"
          @selected-rows="setRows"
        >
          <template #actions="{ runAction }">
            <div class="dropdown-actions__item d-flex align-items-center" @click="runAction('limity')">
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-ico-upravitzarizeni.svg" />
              </div>
              {{ $t("limity") }}
            </div>
          </template>
        </CustomTable>
      </div>

      <div v-if="openedDetail.length > 0">
        <ServiceDetail
          :opened="openedDetail"
          :service="selectedService"
          @close-box="toggleDetailModal"
          @open-box="toggleDetailModal"
        />
      </div>
      <div v-if="openedDetailSim.length > 0">
        <ServiceSimDetail
          :opened="openedDetailSim"
          :service="selectedService"
          @close-box="toggleDetailServiceModal"
          @open-box="toggleDetailServiceModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import CustomTable from "@/components/custom-table/table.vue"
import ServiceDetail from "@/components/modals/admin/customer/service.vue"
import ServiceSimDetail from "@/components/modals/admin/customer/serviceSim.vue"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"

export default {
  components: {
    CustomTable,
    ServiceDetail,
    ServiceSimDetail,
    RadioHelp,
    RadioOpenClose
  },
  props: {
    project: Object
  },
  setup() {
    const projectStore = useProjectStore()
    const configStore = useConfigStore()

    return { projectStore, configStore }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: true,
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      services: [],
      openedItem: {},
      selectedRows: [],
      openedDetail: [],
      openedDetailSim: [],
      selectedService: {},
      loading: true
    }
  },
  computed: {
    storedProject() {
      return this.projectStore.selectedProject
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    }
  },
  watch: {
    radioDisabled() {
      this.showHelp = !this.radioDisabled
    },
    storedProject() {
      this.loadServices()
    }
  },
  mounted() {
    if (this.storedProject) {
      if (this.storedProject.projectId !== this.projectId) {
        this.projectStore.setProject(
          this.projectStore.projectList.find((project) => project.projectId === this.projectId)
        )
        this.projectStore.setProjectById(this.projectId)
      }
      this.loadServices()
    }
    this.showHelp = !this.radioDisabled
  },
  methods: {
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    loadServices() {
      this.services = []
      axios
        .get(process.env.VUE_APP_API + "/projects/" + this.storedProject.projectId + "/services?limit=1000")
        .then((result) => {
          this.services = result.data.data
          for (let i = 0; i < result.data.data.length; i++) {
            if (result.data.data[i].suspended === true || result.data.data[i].discontinued === true) {
              result.data.data[i].notSelectable = true
              result.data.data[i].customRowClass = "gray-text-light"
            }

            if (result.data.data[i].suspended === false && result.data.data[i].discontinued === false) {
              result.data.data[i].custState = "Aktivní"
            } else if (result.data.data[i].suspended === true && result.data.data[i].discontinued === false) {
              result.data.data[i].custState = "Suspendovaná"
            } else if (result.data.data[i].discontinued === true) {
              result.data.data[i].custState = "Deaktivní"
            }
          }

          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    openItem(item) {
      this.openedItem = item
    },
    setRows(rows) {
      this.selectedRows = rows
    },
    toggleDetailModal(box) {
      if (this.openedDetail.indexOf(box) > -1) {
        if (box === undefined) {
          this.openedDetail = []
        } else {
          this.openedDetail.splice(this.openedDetail.indexOf(box), 1)
        }
      } else {
        this.openedDetail.push(box)
      }
    },
    toggleDetailServiceModal(box) {
      if (this.openedDetailSim.indexOf(box) > -1) {
        if (box === undefined) {
          this.openedDetailSim = []
        } else {
          this.openedDetailSim.splice(this.openedDetailSim.indexOf(box), 1)
        }
      } else {
        this.openedDetailSim.push(box)
      }
    },
    openServiceDetail(item) {
      this.selectedService = item
      let isSim = this.selectedService.productElementId === "s_iot8681"
      if (isSim) {
        this.openedDetailSim.push("serviceDetail")
      } else {
        this.openedDetail.push("serviceDetail")
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
